import React, { useState, useEffect } from "react";
import { Container, Title, Text, Loader, Group, Space } from '@mantine/core';
import { useQuery } from "@tanstack/react-query";
import * as App from "./../model/App";
import { Statistics } from "../model/App/Data/App";

export default function Page() {
    const [numTrademarkApplicationsPerYear, setNumTrademarkApplicationsPerYear] = useState<{ year: number, numApplications: number}[]>([]);
    const [numPatentApplicationsPerYear, setNumPatentApplicationsPerYear] = useState<{ year: number, numApplications: number}[]>([]);

    // Load trademarks...
    const { isLoading: isLoadingTrademarks, isError: isErrorTrademarks, data: trademarks } = useQuery(["trademarks"], async () => { 
        const userID = await App.Firebase.Auth.getEffectiveUserID() || "";
        return App.Firebase.Read.getTrademarks(userID); 
    });

    // Load patents...
    const { isLoading: isLoadingPatents, isError: isErrorPatents, data: patents } = useQuery(["patents"], async () => { 
        const userID = await App.Firebase.Auth.getEffectiveUserID() || "";
        return App.Firebase.Read.getPatents(userID); 
    });

    useEffect(() => {
        if (trademarks) {
            const arrTrademarks = Object.values(trademarks);
            const tmAppsPerYear = Statistics.getNumApplicationsPerYear(arrTrademarks);
            setNumTrademarkApplicationsPerYear(tmAppsPerYear);
        }

        if (patents) {
            const arrPatents = Object.values(patents);
            const ptAppsPerYear = Statistics.getNumApplicationsPerYear(arrPatents);
            setNumPatentApplicationsPerYear(ptAppsPerYear);
        }

    }, [trademarks, patents]);

    return (
        <Container ml={0} mr={30} style={{ maxWidth: "100%" }}>
            <Group position="apart">
                <Title>Statistics</Title>
            </Group>

            {/* Trademarks */}
            <Text size="lg" style={{ fontWeight: "bold" }}>Trademarks</Text>
            {isLoadingTrademarks 
                ? <Loader /> 
                : 
                    <Container>
                        <Text weight="bold" style={{ textDecoration: "underline" }}>Total Trademarks:</Text> 
                        <Text>{Object.keys(trademarks || {}).length}</Text>
                        <Space h="md" />

                        <Text weight="bold" style={{ textDecoration: "underline" }}>Applications per Year:</Text>
                        <NumApplicationsPerYear data={numTrademarkApplicationsPerYear} />
                    </Container>
            }

            {/* Patents */}
            <hr />
            <Text size="lg" style={{ fontWeight: "bold" }}>Patents</Text>
            {isLoadingPatents 
                ? <Loader /> 
                : 
                    <Container>
                        <Text weight="bold" style={{ textDecoration: "underline" }}>Total Patents:</Text> 
                        <Text>{Object.keys(patents || {}).length}</Text>
                        <Space h="md" />

                        <Text weight="bold" style={{ textDecoration: "underline" }}>Applications per Year:</Text>
                        <NumApplicationsPerYear data={numPatentApplicationsPerYear} />
                    </Container>
            }
            
            <Space h="md" />
        </Container>
    );
}

function NumApplicationsPerYear({ data }: { data: { year: number, numApplications: number}[] }) {
    return (
        <div>
            {data.sort((a,b) => { return b.year - a.year }).map((item, index) => {
                return (
                    <div key={index} style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gridGap: "10px" }}>
                        <Text>{item.year}</Text>
                        <Text>{item.numApplications}</Text>
                    </div>
                );
            })}
        </div>
    );
}